import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDrink = function SvgDrink(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0ZM12.953 26.789a1 1 0 1 0 0 2H22.1a1 1 0 1 0 0-2h-3.573v-5.86l-.001-.053c3.315-.363 5.86-2.527 5.86-5.662L23.242 7.21H11.81l-1.143 8.003c0 3.135 2.545 5.3 5.86 5.662a.96.96 0 0 0-.001.053v5.86h-3.573Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgDrink;